<!-- Created by Arga Ghulam Ahmad - arga@jojonomic.com -->
<template>
  <div
    id="wrapper"
    class="toggled">

    <!-- header title -->
    <j-headful :title="$route.meta.title"/>

    <!-- Preload -->
    <transition name="fade-slow">
      <j-preload v-if="showPreload" />
    </transition>

    <!-- header border -->
    <j-header v-if="showContent" />

    <!-- Navbar -->
    <j-navbar />

    <!-- sidebar -->
    <j-sidebar
      v-if="showContent"
      :logo="logo"
      :responsive-logo="responsiveLogo"
      :menus-items="menusDetails"
      :products-items="productsDetails"/>

    <!-- Page Content -->
    <div
      v-if="showContent"
      id="page-content-wrapper"
      style="display: block">

      <!-- main content -->
      <div class="wrapper-content">
        <transition name="fadeout">
          <router-view/>
        </transition>
      </div>
    </div>

    <!-- notification screen -->
    <j-loading-screen
      v-if="showContent"
      ref="loadingScreen"
      :message="loading_message"/>
    <j-info-screen
      v-if="showContent"
      ref="infoScreen"
      :message="info_message"/>
    <j-problem-screen
      v-if="showContent"
      ref="problemScreen"
      :message="problem_message"
      :code="problem_code"/>
    <j-success-screen
      v-if="showContent"
      ref="successScreen"
      :message="success_message"/>

  </div>
</template>

<script>
/* eslint-disable global-require,import/no-duplicates,vue/name-property-casing */
import { jPrivCompanySettings } from '@/privilage/company-settings/jPrivCompanySettings';
import { jPrivPackages } from '@/privilage/packages/jPrivPackages';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';
import jPreload from '@/components/jPreload';
import jMixNotificationScreen from '@/mixins/components/notification-screen/jMixNotificationScreen';
import jMixSidebar from '@jojocoders/jojonomic-ui/src/Mixins/jMixSidebar';
import jNavbar from '@/components/header/jNavbar';
import Vue from 'vue';

export default {
  name: 'jWrapper',
  components: {
    jPreload,
    jNavbar,
  },
  mixins: [
    jPrivCompanySettings,
    jPrivPackages,
    jPrivRoles,
    jMixNotificationScreen,
    jMixSidebar,
  ],
  data() {
    return {
      showPreload: true,
      showContent: false,
      arrayOfIcon: [],
      user: {
        submenu: {
          menus: [
            // {
            //   title: 'Account',
            //   id: 1,
            //   text: 'Profile',
            //   hrefout: `${process.env.JOJOPRO_URL}profile/detail`,
            // },
            {
              id: 2,
              text: 'Logout',
              href: '/logout',
            },
          ],
        },
      },
    };
  },
  computed: {
    menusDetails() {
      return [
        {
          parent: {
            name: 'HOME',
            icon: 'file-text-o',
            isShow: true,
          },
          child: [
            {
              name: 'MY HOME',
              href: '/home',
              icon: 'calendar-minus-o',
              isShow: true,
            },
            {
              name: 'DASHBOARD',
              href: '/dashboard',
              icon: 'calendar-minus-o',
              isShow: true,
            },
          ],
        },
        {
          parent: {
            name: 'EXAMPLE',
            icon: 'building',
            href: '/example/list',
            isShow: true,
          },
        },
      ];
    },
  },
  mounted() {
    setInterval(() => {
      if (!Vue.ls.get('Token')) {
        this.$router.replace('/logout');
        window.location = '/';
      }
    }, 1000);
  },
  created() {
    const request = {
      pagination: {
        limit: 0,
        page: 1,
        column: 'id',
        ascending: false,
        query: '',
      },
    };
    this.$store.dispatch('jStoreLogin/getProfileAndRole', request);

    setTimeout(() => {
      this.showPreload = false;
    }, 3000);
    setTimeout(() => {
      this.showContent = false;
    }, 1000);
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/jWrapper.vue